import Vue from 'vue';

import './assets/zstar/index.css'
import ElementUI from 'element-ui';

Vue.use(ElementUI);
Vue.prototype.$message = ElementUI.Message
